import { render } from "./ConsultantsFind.vue?vue&type=template&id=910ab306"
import script from "./ConsultantsFind.vue?vue&type=script&lang=js"
export * from "./ConsultantsFind.vue?vue&type=script&lang=js"
script.render = render

export default script